import Component from './Component'
import loadCSS from './../css/VideoPlayer'
import { addClass } from './../css/css'
import { isTouchDevice } from './../misc/device'
import { distanceBetweenCoordinates } from './../misc/math'

const VideoPlayer = function(options){
  Component.call(this)

  this.path_ = options.path
  this.poster_ = options.poster
  this.autoPlay_ = options.autoPlay

  this.bindedStartAnimatingProgressBar_ = this.startAnimatingProgressBar_.bind(this)
}
VideoPlayer.prototype = new Component()

VideoPlayer.prototype.createDom = function(){
  loadCSS()

  const cSvg = this.dom_.createElementNS.bind(this.dom_, 'http://www.w3.org/2000/svg')

  this.videoElement_ = this.dom_.createElement('video')
  //this.videoElement_ = document.createElement('video')
  this.videoElement_.src = this.path_
  this.videoElement_.poster = this.poster_
  this.videoElement_.playsInline = true
  if (this.autoPlay_){
    this.videoElement_.muted = true
  }
  var playIcon = cSvg(
    'svg', 
    {
      width: "23", 
      height: "28", 
      viewBox: "0 0 23 28",
      fill: "none",
      style: "transform: translateX(3px) translateY(1px);",
    },
    cSvg(
      'path', 
      { 
        'd': "M4.27734 1.03516L21.1523 11.3477C21.9727 11.875 22.5 12.8125 22.5 13.75C22.5 14.7461 21.9727 15.6836 21.1523 16.1523L4.27734 26.4648C3.39844 26.9922 2.28516 27.0508 1.40625 26.5234C0.527344 26.0547 0 25.1172 0 24.0625V3.4375C0 2.44141 0.527344 1.50391 1.40625 1.03516C2.28516 0.507812 3.39844 0.507812 4.27734 1.03516Z",
        'fill': "white"
      },
    ) 
  )
  this.playButton_ = this.dom_.createElement('button', { 'class': 'mainButton mainButtonPlay' }, playIcon)

  var pauseIcon = cSvg(
    'svg',
    {
      width: "19", 
      height: "23", 
      viewBox: "0 0 19 23",
      fill: "none",
      style: "transform: translateY(-1px);",
    },
    cSvg(
      'path',
      {
        'd': "M2.8125 0.5H4.6875C6.21094 0.5 7.5 1.78906 7.5 3.3125V20.1875C7.5 21.7695 6.21094 23 4.6875 23H2.8125C1.23047 23 0 21.7695 0 20.1875V3.3125C0 1.78906 1.23047 0.5 2.8125 0.5ZM14.0625 0.5H15.9375C17.4609 0.5 18.75 1.78906 18.75 3.3125V20.1875C18.75 21.7695 17.4609 23 15.9375 23H14.0625C12.4805 23 11.25 21.7695 11.25 20.1875V3.3125C11.25 1.78906 12.4805 0.5 14.0625 0.5Z", 
        'fill': "white",
      }
    )
  )
  this.pauseButton_ = this.dom_.createElement('button', { 'class': 'mainButton mainButtonPause' }, pauseIcon)

  var unMuteIcon = cSvg(
    'svg',
    {
      width: "19", 
      height: "16", 
      viewBox: "0 0 19 16", 
      fill: "none",
    },
    cSvg(
      'path',
      {
        d: "M9.90625 1.09375C10.25 1.25 10.5 1.625 10.5 2V14C10.5 14.4062 10.25 14.75 9.90625 14.9375C9.53125 15.0938 9.125 15.0312 8.8125 14.75L4.59375 11H2.5C1.375 11 0.5 10.125 0.5 9V7C0.5 5.90625 1.375 5 2.5 5H4.59375L8.8125 1.28125C9.125 1 9.53125 0.9375 9.90625 1.09375ZM13.7812 5.21875L15.5 6.9375L17.2188 5.21875C17.5 4.9375 17.9688 4.9375 18.25 5.21875C18.5625 5.53125 18.5625 6 18.25 6.28125L16.5312 8L18.25 9.71875C18.5625 10.0312 18.5625 10.5 18.25 10.7812C17.9688 11.0938 17.5 11.0938 17.2188 10.7812L15.5 9.0625L13.7812 10.7812C13.4688 11.0938 13 11.0938 12.7188 10.7812C12.4062 10.5 12.4062 10.0312 12.7188 9.71875L14.4375 8L12.7188 6.28125C12.4062 6 12.4062 5.53125 12.7188 5.21875C13 4.9375 13.4688 4.9375 13.7812 5.21875Z",
        fill: "white"
      }
    )
  )
  this.unMuteButton_ = this.dom_.createElement(
    'button', 
    { 'class': 'smallButton smallButtonUnMute' }, 
    this.dom_.createElement('div', null, unMuteIcon)
  )

  var muteIcon = cSvg(
    'svg',
    {
      width: "18", 
      height: "16", 
      viewBox: "0 0 18 16", 
      fill: "none",
    },
    cSvg(
      'path',
      {
        d: "M9.90625 1.09375C10.25 1.25 10.5 1.625 10.5 2V14C10.5 14.4062 10.25 14.75 9.90625 14.9375C9.53125 15.0938 9.125 15.0312 8.8125 14.75L4.59375 11H2.5C1.375 11 0.5 10.125 0.5 9V7C0.5 5.90625 1.375 5 2.5 5H4.59375L8.8125 1.28125C9.125 1 9.53125 0.9375 9.90625 1.09375ZM15.2812 3.34375C16.625 4.46875 17.5 6.125 17.5 8C17.5 9.90625 16.625 11.5625 15.2812 12.6562C14.9375 12.9375 14.4688 12.875 14.2188 12.5625C13.9375 12.25 14 11.7812 14.3125 11.5C15.3438 10.6875 16 9.4375 16 8C16 6.59375 15.3438 5.34375 14.3125 4.53125C14 4.25 13.9688 3.78125 14.2188 3.46875C14.4688 3.15625 14.9375 3.09375 15.2812 3.34375ZM13.375 5.6875C14.0625 6.25 14.5 7.0625 14.5 8C14.5 8.96875 14.0625 9.78125 13.375 10.3438C13.0625 10.5938 12.5938 10.5625 12.3125 10.2188C12.0625 9.90625 12.125 9.4375 12.4375 9.1875C12.7812 8.90625 13 8.46875 13 8C13 7.53125 12.7812 7.125 12.4375 6.84375C12.125 6.59375 12.0625 6.125 12.3125 5.78125C12.5938 5.46875 13.0625 5.4375 13.375 5.6875Z",
        fill: "white"
      }
    )
  )
  this.muteButton_ = this.dom_.createElement(
    'button', 
    { 'class': 'smallButton smallButtonMute' }, 
    this.dom_.createElement('div', null, muteIcon)
  )

  this.progressBar_ = this.dom_.createElement('progress')
  //this.progressBar_ = document.createElement('progress')
  this.progressBar_.value = 0
  this.progressHitbox_ = this.dom_.createElement('div', { 'class': 'progressHitbox' }, this.progressBar_)
  this.progressBarContainer_ = this.dom_.createElement(
    'div', 
    { 'class': 'progressContainer' }, 
    this.progressHitbox_
  )

  this.element_ = this.dom_.createElement('div', { 'class': 'VideoPlayer' }, 
    this.videoElement_,
    this.playButton_,
    this.pauseButton_,
    this.unMuteButton_,
    this.muteButton_,
    this.progressBarContainer_,
  )

  if (this.autoPlay_){
    this.playInternal_()
  }

  this.resetControls_()
}

VideoPlayer.prototype.resetControls_ = function(){

  // Defensive coding if this is called after the instance is destroyed
  if (!this.element_)
    return

  this.element_.className = 'VideoPlayer'
  this.muteButton_.className = 'smallButton smallButtonMute'

  if (this.videoElement_.paused){
    addClass(this.element_, 'paused')
  } else {
    addClass(this.element_, 'playing')
  }

  if (this.videoElement_.muted){
     addClass(this.element_, 'muted')
  }

  if (this.showControls_)
    addClass(this.element_, 'touchStart')

  if (this.showMuteButton_)
    addClass(this.muteButton_, 'showMuteButton')

  if (isTouchDevice())
    addClass(this.element_, 'touchDevice')
  else 
    addClass(this.element_, 'notTouchDevice')
}

VideoPlayer.prototype.addEventListeners = function(){
  this.listen(this.videoElement_, 'click', this.onVideoElementClick_.bind(this))
  this.listen(this.videoElement_, 'touchstart', this.onVideoElementTouchStart_.bind(this))
  this.listen(this.videoElement_, 'touchend', this.onVideoElementTouchEnd_.bind(this))
  this.listen(this.muteButton_, 'click', this.onMuteButtonClick_.bind(this))
  this.listen(this.unMuteButton_, 'click', this.onUnMuteButtonClick_.bind(this))
  this.listen(this.videoElement_, 'play', this.resetControls_.bind(this))
  this.listen(this.videoElement_, 'playing', this.resetControls_.bind(this))
  this.listen(this.videoElement_, 'ended', this.resetControls_.bind(this))
  this.listen(this.progressHitbox_, 'click', this.onProgressBarClick_.bind(this))
}


VideoPlayer.prototype.onMuteButtonClick_ = function(e){
  e.preventDefault()
  e.stopPropagation()
  this.videoElement_.muted = true
  this.showMuteButton_ = false
  this.showControlsForMobile_()
  this.resetControls_()
}


VideoPlayer.prototype.removeMuteButton_ = function(){
  //console.log('VideoPlayer#removeMuteButton_')
  this.showMuteButton_ = false
  this.resetControls_()
}

VideoPlayer.prototype.onUnMuteButtonClick_ = function(e){
  e.preventDefault()
  e.stopPropagation()
  this.videoElement_.muted = false
  //this.showControlsForMobile_()

  this.showMuteButton_ = true
  clearTimeout(this.removeMuteButtonTimeout_)
  this.removeMuteButtonTimeout_ = setTimeout(this.removeMuteButton_.bind(this), 4000)

  this.resetControls_()
}

VideoPlayer.prototype.paintProgressBar_ = function(){
  var duration = this.videoElement_.duration
  if (Number.isNaN(duration) || duration == 0){
    this.progressBar_.value = 0
    return
  }
  this.progressBar_.value = this.videoElement_.currentTime / duration
}

VideoPlayer.prototype.startAnimatingProgressBar_ = function(){
  this.paintProgressBar_()
  if (!this.videoElement_.paused)
    window.requestAnimationFrame(this.bindedStartAnimatingProgressBar_)
}

VideoPlayer.prototype.onProgressBarClick_ = function(e){
  var value = e.offsetX / e.target.clientWidth
  this.videoElement_.currentTime = value * this.videoElement_.duration
  this.paintProgressBar_()
  this.showControlsForMobile_()
  this.resetControls_()
}

VideoPlayer.prototype.onVideoElementClick_ = function(){
  if (this.videoElement_.paused){
    this.playInternal_()
  } else {
    this.videoElement_.pause()
  }
  this.resetControls_()
}

VideoPlayer.prototype.playInternal_ = function() {
  this.videoElement_.play()
  window.requestAnimationFrame(this.bindedStartAnimatingProgressBar_)
  this.dispatchEvent('play')
}

VideoPlayer.prototype.onVideoElementTouchStart_ = function(e){
  this.touchDownEvent_ = e.changedTouches[0]
}

VideoPlayer.prototype.onVideoElementTouchEnd_ = function(e){
  //console.log('VideoPlayer#onVideoElementTouchEnd_#e', e)

  if (this.touchDownEvent_){
    var distance = distanceBetweenCoordinates(
      [this.touchDownEvent_.screenX,this.touchDownEvent_.screenY],
      [e.changedTouches[0].screenX,e.changedTouches[0].screenY],
    )
    // Don't trigger this after a drag
    if (distance > 3)
      return
  }

  // DOMException: play() failed because the user didn't interact with the document first.
  // On mobile we don't want it to bubble up and trigger the mouse over event
  e.stopPropagation()
  e.preventDefault()

  if (this.videoElement_.paused){
    // Allow it to propagate through and trigger a click, so that the click
    // handler will play the video.
    // Can't play the video in this event as it will throw the error
    this.playInternal_()
    this.resetControls_()
    return
  }
  
  // Video is playing
  if (this.showControls_){
    // Menu buttons are already showing so lets pause the video
    this.videoElement_.pause()
  }
    
  this.showControlsForMobile_()
  this.resetControls_()
  
}

VideoPlayer.prototype.removeTouchStart_ = function(){
  this.showControls_ = false
  this.resetControls_()
}

/**
 * When on mobile this shows the video controls while the video is playing
 * for 5 seconds. Will not call `resetControls()` so follow it with a call
 * to that to paint the controls on the screen.
 */
VideoPlayer.prototype.showControlsForMobile_ = function(){
  // We want the touchStart class to persist for 5 seconds, so that we can
  // show the controls for 5 seconds before fading out

  this.showControls_ = true
  clearTimeout(this.removeTouchStartTimeout_)
  this.removeTouchStartTimeout_ = setTimeout(this.removeTouchStart_.bind(this), 4000)
}

VideoPlayer.prototype.getCurrentTime = function(){
  if (!this.videoElement_)
    return 0
  return this.videoElement_.currentTime
}

export default VideoPlayer
